import { LoadingAnimation, LoadingAnimationProps } from 'kennek/components';

const LoadingAnimationPlat = (props: LoadingAnimationProps) => {
  return <LoadingAnimation color="standard" {...props} />;
};

export default LoadingAnimationPlat;
